<template>
	
	<div class="news-single d-flex flex-column">
		<div class="row">
            <div class="col-12 col-md-8 text-block">
                <h1 class="mb-0">{{news.title}}</h1>
                <p class="grey small">{{news.valid_from | date}}</p>
            </div>
        </div>
        <div class="row mb-auto">
            <div class="col-12 col-md-8 text-block">
                <div class="body" v-html="news.body"></div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 text-block" v-if="hasGallery">
                <news-gallery class="gallery" :data="news.gallery"></news-gallery>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-8">
                <p>
                    <a :href="backUrl">
                        <button class="btn green">
                            Nazaj na seznam novic
                        </button>
                    </a>
                </p>
            </div>
        </div>
	</div>
</template>

<script>
import slugify from 'slugify'
import queryString from 'query-string'
import NewsGallery from './NewsGallery'

export default {
	components: {
        NewsGallery
    },
    props: ['news'],
	data() {
		return {
		};
	},
	mounted() {
	},
	methods: {
        
	},
    filters: {
        capitalize(text) {
            return text.charAt(0).toUpperCase() + text.slice(1)
        },
        date(value) {
            let date = new Date(Date.parse(value))
            return date.toLocaleDateString('sl-SI')
        }
	},
	computed: {
		backUrl() {
            return this.route('warehouse.news.all')
        },
        hasGallery() {
            return this.news.gallery.length > 0
        }
	}
};
</script>

<style lang="scss" scoped>



</style>



// WEBPACK FOOTER //
// resources/assets/js/components/NewsSingle.vue